import { render } from "./growthOverview.vue?vue&type=template&id=5767aee6"
import script from "./growthOverview.vue?vue&type=script&lang=js"
export * from "./growthOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__